import './start.css';
//import './snowing.css';
import { Link } from "react-router-dom";
import { collectionsMap } from '../../model/collections';
import { assetsMap, imageInitializer } from "../../model/assets.js";
import { Banner } from "./banner.js";
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import { TouchSwap } from './touchSwap';
import { PersonalPage } from '../personal/personal';
import { Navigation } from './navigation/navigation';

const highlightList = ["ginProject", "seh", "oceatika"];

const Start = ({ origin }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const pageRoute = origin || urlParams.get("display");
    const [assets, setAssets] = useState(assetsMap);
    const [collectionId, setCollectionId] = useState(Math.floor(Math.random() * highlightList.length));
    const [swap, setSwap] = useState([pageRoute || "home", "stopped"]);
    const cv_file = useIntl().messages.cv_file;
    let toggleId;

    const getCollection = (id = 0) => {
        const source = highlightList[id];
        const element = collectionsMap[source];
        return {
            image: assets[element.coverImage].file,
            url: element.start ? `start/${element.start}` : `view?id=${highlightList[id]}`,
            banner: element.banner || "",
            coverSize: element.coverSize,
            coverColor: element.coverColor
        }
    }

    const toggleSwap = (res) => {
        clearTimeout(toggleId);
        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
        setSwap([res, "animating"]);
        document.querySelector("footer").classList.add("none");
        toggleId = setTimeout(() => {
            setSwap([res, "stopped"]);
            document.querySelector("footer").classList.remove("none");
            document.body.style.overflow = "auto";
        }, 1000);
    }

    useEffect(() => {
        let url = window.location.href;
        if (pageRoute) {
            url = url.split("?display=")[0];
        }
        if (["portfolio", "home"].includes(swap[0])) {
            const temp = url.split("remyjeuniaux");
            temp[1] = swap[0];
            url = temp.join("remyjeuniaux/");
        }
        if (url !== window.location.href) {
            window.history.replaceState({}, document.title, url);
        }
      }, [pageRoute, swap]);

    useEffect(() => {
        let timeout;
        if(assets.busy) {
            timeout = imageInitializer(setAssets);
        }
        return () => {
            clearTimeout(timeout);
        };
      }, [assets]);
    useEffect(() => {
        if (swap[0] === "portfolio") {
            let timeoutPage;
            const update = () => {
                setCollectionId((collectionId + 1) % highlightList.length);
                timeoutPage = setTimeout(() => update(), 7000);
            }
            if (highlightList.length > 1) {
                timeoutPage = setTimeout(() => update(), 9000);
            }
            return () => {
                clearTimeout(timeoutPage);
            };
        }
    }, [swap, collectionId]);

    const collection = getCollection(collectionId);
    return (
        <div className={`view homeView ${swap.join(" ")}`}>
            {window.isWinter && swap[0] === "home" && [...Array(17).keys()].map((i) => <div key={i} className="fSnow round" style={{left: `${Math.random()*90}vw`, transform: `scale(${1 + Math.random() * 2})`, animationDelay: `${Math.random()*5 + 2}s`}}/>) }
            <h2 className="view-title mainName themed"><span style={{fontSize: 0}}>REMY AMAND - JEUNIAUX</span><img draggable="false" alt="Rémy Amand - Jeuniaux" src="./assets/icon.svg"/></h2>
            <p className="hiddenTextForFutureIndexation"><FormattedMessage id="hiddenTextForFutureIndexation"/></p>
            <a href={`./content/${cv_file}.pdf`} download className="cv_sticker align-center round">
                <span><FormattedMessage id="cv_sticker"/></span>
            </a>
            {
                swap[0] === "home" &&
                <Navigation/>
            }
            <TouchSwap toggleSwap={toggleSwap} currentSwap={swap[0]}/>
            { (swap[0] === "home" || swap[1] !== "stopped") &&
                <PersonalPage toggleSwap={toggleSwap}/>
            }
            { (swap[0] === "portfolio" || swap[1] !== "stopped") &&
                <div className="cards-container swapMain">
                    <div className="card main-card" key={collection.url}>
                        <div className="card-background" style={{backgroundImage: `${collection.coverSize === "contain" && collection.coverColor ? `radial-gradient(circle, ${collection.coverColor}00 max(20vh, 105px), ${collection.coverColor} max(30vh, 150px)),` : ""} url(${collection.image})`, filter: collection.coverSize  ? "" : "blur(25px)", backgroundSize: collection.coverSize ? collection.coverSize === "contain" ? "auto 100%" : collection.coverSize : "250%", backgroundPosition: "center", backgroundRepeat: collection.coverSize ? "no-repeat" : "repeat"}}/>
                        {!collection.coverSize && <img draggable="false" className="card-image" alt="" src={collection.image}/>}
                        <Link to={`../collections/${collection.url}`}><button className="reveal reveal-area align-center action bottom left inner"><FormattedMessage id="openCollection"/></button></Link>
                        <Banner text={collection.banner}/>
                    </div>
                    <div className="card themes-card">
                        <Link to={"../collections"}><button className="reveal reveal-area align-center action bottom left inner"><FormattedMessage id="showCollections"/></button></Link>
                    </div>
                    <div className="card gallery-card ">
                        <Link to={"../gallery"}><button className="reveal reveal-area align-center action bottom left inner"><FormattedMessage id="seeAll"/></button></Link>
                    </div>
                </div>
            }
        </div>
    );
}

export default Start;